export const residentManagementEmarRoutePrefixes = [
  "/biz/resident",
  "/resident-management",
  "/emar",
  "/resident",
  "/residents",
];
